export default {
  isTestnet: false,
  explorerLink: 'https://explorer.celo.org/tx/'
}
